import { render, staticRenderFns } from "./card.vue?vue&type=template&id=f4d0a1a4&scoped=true"
import script from "./card.vue?vue&type=script&lang=ts"
export * from "./card.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./card.vue?vue&type=style&index=0&id=f4d0a1a4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f4d0a1a4",
  "cbbe5516"
  
)

export default component.exports